import { FormGroup } from "@angular/forms";

export class PasswordConfirmValidator {
  static passwordMatch(userForm: FormGroup) {
    const password = userForm.controls.password.value;
    const confirmPassword = userForm.controls.confirmPassword.value;

    if (confirmPassword.length <= 0) {
      return null;
    }

    if (confirmPassword !== password) {
      return {
        doesMatchPassword: true
      };
    }

    return null;
  }
}
